const FetchLocalStorageDataByPath = (params, path) => {
  try {
    console.log('params', params, 'localStorage param', localStorage.getItem(params));
    const keyData = localStorage.getItem(params) && JSON.parse(localStorage.getItem(params));
    if (keyData === null) return;
    console.log('keyData', keyData);
    const object = path.split('.').reduce((acc, curr) => acc[curr], keyData);
    return object;
  } catch (err) {
    console.log(err, 'err');
  }
};

export default FetchLocalStorageDataByPath;
